import { Node_Type } from 'ricos-schema';

export const HTML_BUTTONS = {
  alignment: `${Node_Type.HTML}.alignment`,
  edit: `${Node_Type.HTML}.edit`,
  width: `${Node_Type.HTML}.width`,
  height: `${Node_Type.HTML}.height`,
};
